import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/components/common/Header.tsx");
